<template>
    <transition name="update-prompt">
        <div class="app-update-prompt" role="alertdialog" aria-live="polite">
            <div class="info-box is-card">
                <div class="box-main">
                    <div class="box-icon"><i class="fad fa-sync-alt fa-2x"></i></div>
                    <div class="box-body">
                        <div class="box-title">App Update Available</div>
                        <div class="box-text">
                            <template v-if="latest">Version {{ latest }} is ready.</template>
                            <template v-else>A new version of the app is ready.</template>
                            Reload to update; anything you have not saved will be lost.
                        </div>
                    </div>
                </div>
                <div class="box-actions">
                    <div class="box-buttons">
                        <b-button size="is-small" type="is-light" @click="$emit('later')">Later</b-button>
                        <b-button size="is-small" type="is-primary" icon-pack="fas" icon-left="sync-alt" @click="$emit('reload')">Reload</b-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
// Stale-build prompt (see utils/appVersion.js). Same card anatomy as the
// dashboard's info boxes so it reads as part of the app, not a library toast.
export default {
    name: 'AppUpdatePrompt',
    props: {
        // The build the API is advertising (Latest-App-Version); null when the
        // prompt came from a chunk-load failure rather than the header.
        latest: { type: String, default: null }
    }
};
</script>

<style lang="scss" scoped>
.app-update-prompt {
    position: fixed;
    right: 1.25rem;
    bottom: 1.25rem;
    width: 380px;
    max-width: calc(100vw - 2rem);
    z-index: 999990; // above the page and the navbar, below Buefy modals' overlay siblings

    .box-icon i {
        color: #366ea5;
    }
}

.update-prompt-enter-active,
.update-prompt-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}
.update-prompt-enter,
.update-prompt-leave-to {
    opacity: 0;
    transform: translateY(12px);
}

@media (max-width: 768px) {
    .app-update-prompt {
        right: 1rem;
        left: 1rem;
        bottom: 1rem;
        width: auto;
    }
}
</style>
